import React, { useState, useEffect, memo, useContext } from "react";
import { Link } from "react-router-dom";
import { getNextLevel } from "utils/builder/IModelsTree";
import { BuilderDataContext } from "components/BuilderContext";
import { useDashboardState } from "components/DashboardContext";
import { searchLevel, searchTreeFun, findFoldersTreeObj } from "utils/helpers";
import classNames from "classnames";
import "./ProjectItem.scss";

import { ReactComponent as ProjectIcon } from "static/icons/project.svg";

const ProjectItem = memo(
  ({
    item: {
      children,
      id,
      text,
      type,
      stat,
    },
    treeAction,
    searchValue,
    level,
  }) => {
    const {
      foldersTree,
      activeFolder,
      setFoldersTree,
      setActiveFolder,
      setIsFolderLoading,
    } = useDashboardState();

    const { builderData, setBuilderData } = useContext(BuilderDataContext);
    const [list, setList] = useState(null);
    const [active, setActive] = useState("close");

    const handleClick = () => {
      setActiveFolder(id);

      if (!list) {
        setIsFolderLoading(true);

        getNextLevel(id)
          .then(res => {
            treeAction(id, res, true, level);

            return res;
          })
          .then(res => {
            const requestedObj = findFoldersTreeObj(id, foldersTree);

            if (requestedObj) {
              if (!requestedObj?.childrenArr?.length) {
                requestedObj.childrenArr = res;
              }
            }

            setList(res);
            setFoldersTree(foldersTree);
          })
          .then(() => {
            setActive("active");
          })
          .finally(() => {
            setIsFolderLoading(false);
          });
      }
    };

    const handleClick2 = () => {
      setBuilderData({
        ...builderData,
        project: {
          id,
          type,
          children,
          text,
        },
      });
    };

    useEffect(() => {
      let tree = JSON.parse(localStorage.getItem("tree"));

      if (tree) {
        if (searchTreeFun(tree, id)) {
          setActive("load");

          getNextLevel(id)
            .then(res => {
              const requestedObj = findFoldersTreeObj(id, foldersTree);

              if (requestedObj) {
                if (!requestedObj?.childrenArr?.length) {
                  requestedObj.childrenArr = res;
                }
              }

              setFoldersTree(foldersTree);
              setList(res);
            })
            .then(() => setActive("active"));
        }
      }
    }, []);

    useEffect(() => {
      const searchFunction = async () => {
        setActive("load");

        const { list, condition } = await searchLevel(
          searchValue,
          getNextLevel,
          id
        );

        setActive(condition ? "active" : "close");
        setList(list);
        treeAction(id, list, condition, level);
      };
      if (level === 1 && searchValue !== null) {
        searchFunction();
      }
    }, [searchValue]);

    if (children) {
      return (
        <div className={`project__item ${stat ? "searched_folder" : ""}`}>
          <div
            className="project__title"
            onClick={handleClick}
          >
            <ProjectIcon
              className={classNames({
                'project__icon': true,
                'project__icon--active': activeFolder === id,
              })}
            />

            <h5
              className={classNames({
                'project__text': true,
                'project__text--active': activeFolder === id,
              })}
            >
              {text}
            </h5>
          </div>
        </div>
      );
    } else {
      return (
        <div className="folder-title single_folder">
          <Link to={`/project/${id}`} onClick={handleClick2}>
            {text}
          </Link>
        </div>
      );
    }
  }
);

export default ProjectItem;
